import { useState } from 'react'
import { useAuth } from 'react-oidc-context'
import { NavLink } from 'react-router-dom'
import logo from '../../Assets/logo.png'
import './Navbar.css'

const { REACT_APP_COGNITO_DOMAIN, REACT_APP_COGNITO_CLIENT_ID, REACT_APP_PUBLIC_SITE } = process.env

interface Props {
  showLinks: boolean
}

export const Navbar = ({ showLinks }: Props) => {
  const auth = useAuth()
  const [menuOpen, setMenuOpen] = useState(false)

  const handleLogout = async () => {
    const refreshToken = auth.user?.refresh_token

    if (refreshToken) {
      await fetch(`${REACT_APP_COGNITO_DOMAIN}/oauth2/revoke`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: `token=${refreshToken}&client_id=${REACT_APP_COGNITO_CLIENT_ID}`,
      })
    }

    // Clear local storage directly without triggering re-render
    Object.keys(localStorage).forEach((key) => {
      if (key.startsWith('oidc.')) {
        localStorage.removeItem(key)
      }
    })

    window.location.href = `${REACT_APP_COGNITO_DOMAIN}/logout?response_type=code&client_id=${REACT_APP_COGNITO_CLIENT_ID}&logout_uri=${encodeURIComponent(REACT_APP_PUBLIC_SITE ?? '')}&scope=openid+email+phone`
  }

  const closeMenu = () => setMenuOpen(false)

  return (
    <>
      <nav className="rapdure-navbar">
        <div className="rapdure-navbar-inner">
          <a className="rapdure-navbar-brand" href="/">
            <img src={logo} alt="Rapdure" height="30" />
          </a>

          {showLinks && (
            <div className="rapdure-nav-links text-center">
              <NavLink
                to="/map"
                className={({ isActive }) =>
                  `rapdure-nav-link ${isActive ? 'rapdure-nav-link--active' : ''}`
                }
              >
                Public Map
              </NavLink>
              <NavLink
                to="/mymap"
                className={({ isActive }) =>
                  `rapdure-nav-link ${isActive ? 'rapdure-nav-link--active' : ''}`
                }
              >
                My Map
              </NavLink>
              <NavLink
                to="/uploader"
                className={({ isActive }) =>
                  `rapdure-nav-link ${isActive ? 'rapdure-nav-link--active' : ''}`
                }
              >
                Upload
              </NavLink>
            </div>
          )}

          <button className="rapdure-btn-logout" onClick={handleLogout}>
            Logout
          </button>

          {/* Hamburger button — mobile only */}
          <button
            className={`rapdure-hamburger ${menuOpen ? 'open' : ''}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Menu"
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </nav>

      {/* Mobile overlay + slide-in menu */}
      <div className={`rapdure-mobile-overlay ${menuOpen ? 'open' : ''}`} onClick={closeMenu} />
      <div className={`rapdure-mobile-menu ${menuOpen ? 'open' : ''}`}>
        {showLinks && (
          <>
            <NavLink
              to="/map"
              className={({ isActive }) =>
                `rapdure-nav-link ${isActive ? 'rapdure-nav-link--active' : ''}`
              }
              onClick={closeMenu}
            >
              Public Map
            </NavLink>
            <NavLink
              to="/mymap"
              className={({ isActive }) =>
                `rapdure-nav-link ${isActive ? 'rapdure-nav-link--active' : ''}`
              }
              onClick={closeMenu}
            >
              My Map
            </NavLink>
            <NavLink
              to="/uploader"
              className={({ isActive }) =>
                `rapdure-nav-link ${isActive ? 'rapdure-nav-link--active' : ''}`
              }
              onClick={closeMenu}
            >
              Upload
            </NavLink>
          </>
        )}
        <button className="rapdure-btn-logout" onClick={handleLogout}>
          Logout
        </button>
      </div>
    </>
  )
}
